import classNames from 'classnames';
import { memo, useCallback, useState } from 'react';

// import { Skeleton } from 'antd';
import MindverseModal from '@/components/modal';

import styles from './index.less';

interface IProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  url?: string;
  className?: string;
  children: React.ReactNode;
}

function HelpIframe(props: IProps): JSX.Element | React.ReactNode {
  const { url, className, children } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [_loading, setLoading] = useState<boolean>(true);

  const handleClick = useCallback<React.MouseEventHandler<HTMLSpanElement>>((e) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleLoadFinish = useCallback(() => {
    setLoading(false);
  }, []);

  if (!url) {
    return children;
  }

  return (
    <>
      <span className={classNames(styles.helpIframe, className)} onClick={handleClick}>
        {children}
      </span>
      <MindverseModal
        className={styles.modalContainer}
        destroyOnClose
        footer={null}
        onCancel={handleClose}
        open={open}
        title="Learn More"
        width={724}
      >
        <iframe
          className={styles.iframe}
          onError={handleLoadFinish}
          onLoad={handleLoadFinish}
          src={url}
        />
        {/* <Skeleton active className={styles.loading} loading={loading} /> */}
      </MindverseModal>
    </>
  );
}

export default memo(HelpIframe);
